import { Stack, Typography } from '@lyearn/ui';

import { DialogNotesProps } from './types';

const DialogNotes = (props: DialogNotesProps) => {
  const { className = 'px-8 mt-24', items } = props;

  if (!items.length) {
    return null;
  }

  return (
    <Stack className={className} direction="col" gapY={16}>
      {items.map(({ Icon, label }, index) => (
        <Stack key={index} gapX={12}>
          <Icon className="h-20 w-20 flex-shrink-0" fillColorToken="icon-active" />
          <Typography color="text-text-primary" variant="body-short-02">
            {label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default DialogNotes;
